import {
  animate,
  state,
  style,
  transition,
  trigger,
  keyframes,
} from '@angular/animations';
import {
  AfterContentInit,
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { map, Subscription } from 'rxjs';
import { LanguageService, UserService } from 'src/app/services';
import { environment, OLD_SITE } from 'src/environments/environment.local';
import { UserFacade } from 'app/modules/dashboard/facades/user.facade';
import { TranslateModule } from '@ngx-translate/core';
import { brandsCarouselComponent } from '@kinomap-dev/ng-ui-lib';
import { RouterLink } from '@angular/router';
import { User } from 'app/models';
import { BrandService } from 'app/services/brand.service';
import {
  Brand,
  PartnerType,
} from '../../../compatibility/models/brand.interface';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-step-one',
  templateUrl: './step1.component.html',
  styleUrls: ['./step1.component.scss'],
  animations: [
    trigger('fadeText', [
      state(
        'false',
        style({
          opacity: 0,
        })
      ),
      state(
        'true',
        style({
          opacity: 1,
        })
      ),
      transition('false => true', animate('250ms ease-in-out')),
    ]),
    trigger('fadeText2', [
      transition(':enter', [
        style({ opacity: 0, width: 0 }),
        animate(
          '250ms ease-in-out',
          keyframes([style({ width: '*' }), style({ opacity: 1 })])
        ),
      ]),
      transition(':leave', [
        style({ opacity: 1, width: '*' }),
        animate(
          '250ms ease-in-out',
          keyframes([style({ opacity: 0 }), style({ width: 0 })])
        ),
      ]),
    ]),
    trigger('fadeTextSlide', [
      state(
        'false',
        style({
          opacity: 0,
          transform: 'translateY(50px)',
        })
      ),
      state(
        'true',
        style({
          opacity: 1,
          transform: 'translateY(0)',
        })
      ),
      transition('false => true', animate('300ms ease-in-out')),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [RouterLink, brandsCarouselComponent, TranslateModule],
})
export class Step1Component
  implements OnInit, OnDestroy, AfterContentInit, AfterViewInit {
  @ViewChild('homeVideo') homeVideo: ElementRef;

  partnerImages: string[];
  subscriptions: Subscription;
  oldSite: string = OLD_SITE;
  currentUser: User;
  cellsToShow: number = 7;
  autoplayInterval: number = 2000;
  animationTiming: Array<Boolean>;
  partnerType: typeof PartnerType = PartnerType;
  lang: string;
  getStartedLink: string;

  constructor(
    private userService: UserService,
    private languageService: LanguageService,
    private brandService: BrandService,
    private readonly userFacade: UserFacade
  ) { }

  ngOnInit(): void {
    this.brandService
      .getBrands()
      .pipe(
        map((brands: Brand[]) => {
          return brands
            .filter((brand: Brand) => brand.partnership === PartnerType.GOLD)
            .map((brand: Brand) => brand.logo);
        })
      )
      .subscribe((brandLogos: string[]) => {
        this.partnerImages = brandLogos;
      });

    this.animationTiming = [false, false, false, false];

    this.languageService.langEmitter.subscribe((el: string) => {
      this.lang = el;
      this.setLink(el);
    });
    this.lang = this.languageService.get();
    this.setLink(this.lang);
    this.subscriptions = this.userFacade.user$.subscribe((user) => {
      this.currentUser = user;
    });

    if (localStorage.getItem('user_access_token')) {
      this.userService.get();
    }
  }

  private setLink(el: string): void {
    switch (el) {
      case 'fr-FR':
        this.getStartedLink = 'https://partner.kinomap.com/demarrer-kinomap';
        break;
      case 'de-DE':
        this.getStartedLink = 'https://partner.kinomap.com/starten';
        break;
      default:
        this.getStartedLink = 'https://partner.kinomap.com/getting-started';
    }
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
    this.animationTiming = [];
  }

  ngAfterViewInit(): void {
    if (this.homeVideo.nativeElement.paused) {
      this.homeVideo.nativeElement.inline = true;
      this.homeVideo.nativeElement.muted = true;
      this.homeVideo.nativeElement.playinline = true;
      this.homeVideo.nativeElement.autoplay = true;
      this.homeVideo.nativeElement.play();
    }
  }

  ngAfterContentInit(): void {
    this.onAppear();
  }

  onAppear(): void {
    setTimeout(() => {
      this.animationTiming[0] = true;
      setTimeout(() => {
        this.animationTiming[1] = true;
        setTimeout(() => {
          this.animationTiming[2] = true;
          setTimeout(() => {
            this.animationTiming[3] = true;
          }, 350);
        }, 350);
      }, 350);
    }, 500);
  }

  register(): void {
    let params: HttpParams = new HttpParams()
      .set('client_id', '50') // le client ID du site-web sur login.kinomap.com
      .set('redirect_uri', window.location.href)
      .set('state', Math.random().toString(36).substring(2, 15));

    if (window.location.href.includes('beta.kinomap.com')) {
      params = params.set('client_id', '54'); // le client ID du site-web sur beta.kinomap.com
    }
    const oauthUrl: string = `${environment.oauth.url}?${params.toString()}`;
    window.location.href = oauthUrl;
  }
}
